import { RoleType } from '@vtblife/event-bus-events';

export function isProfessional(roleType?: RoleType | string) {
    return (
        roleType === RoleType.Professional ||
        roleType === RoleType.Realtor ||
        roleType === RoleType.Makler
    );
}
